import { FileInputAllowedModel, FileInputAllowedTypeModel, FileInputModel } from './file-input.model';

export const DEFAULT_ALLOWED_FILES: FileInputAllowedModel = {
  // Default max file size: 20,480 KB (~20 MB)
  // Source SRM config: maxFileSizeKb = 20480
  maxSize: 20480 * 1024,

  // Allowed filetypes: 'png', 'bmp', 'gif', 'jpeg', 'jpg', 'pdf', 'doc', 'docx', 'xls', 'xlsx'
  types: [
    {
      mimeType: 'image/gif',
      extensions: ['gif'],
    },
    {
      mimeType: 'image/jpeg',
      extensions: ['jpg', 'jpeg'],
    },
    {
      mimeType: 'image/png',
      extensions: ['png'],
    },
    {
      mimeType: 'image/bmp',
      extensions: ['bmp'],
    },
    {
      mimeType: 'application/pdf',
      extensions: ['pdf'],
    },
    {
      mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      extensions: ['docx'],
    },
    {
      mimeType: 'application/msword',
      extensions: ['doc'],
    },
    {
      mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      extensions: ['xlsx'],
    },
    {
      mimeType: 'application/vnd.ms-excel',
      extensions: ['xls'],
    },
  ],
};

export const getAllowedFileSizeBytes = (item: FileInputModel): number => {
  const allowed: FileInputAllowedModel = item.allowed ?? DEFAULT_ALLOWED_FILES;

  return allowed.maxSize;
};

export const getAllowedFileTypes = (item: FileInputModel): FileInputAllowedTypeModel[] => {
  const allowed: FileInputAllowedModel = item.allowed ?? DEFAULT_ALLOWED_FILES;

  return allowed.types;
};

export const getAllowedFileMimeTypes = (item: FileInputModel): string[] => {
  const allowed: FileInputAllowedModel = item.allowed ?? DEFAULT_ALLOWED_FILES;

  return allowed.types.map(type => type.mimeType);
};

export const getAllowedFileExtensions = (item: FileInputModel): string[] => {
  const allowed: FileInputAllowedModel = item.allowed ?? DEFAULT_ALLOWED_FILES;

  return allowed.types.flatMap(type => type.extensions);
};

// File extension and MIME type are compared without case, so 'photo.JPG' is a valid jpg file
export const isAllowedFileType = (fileName: string, mimeType: string, types: FileInputAllowedTypeModel[]): boolean => {
  const extension: string = String(fileName.split('.').pop()).toLowerCase();

  return types.some(type => {
    return type.mimeType.toLowerCase() === mimeType.toLowerCase() && type.extensions.some(allowedExtension => allowedExtension.toLowerCase() === extension);
  });
};

// Allowed characters of an upload file name: letters incl. German umlauts, digits, space and . - _ + ( )
// Everything else is rejected, the name is never changed
export const FILE_NAME_PATTERN: RegExp = /^[A-Za-z0-9ÄÖÜäöüß .\-_+()]+$/;

export const isAllowedFileName = (fileName: string): boolean => {
  return FILE_NAME_PATTERN.test(fileName);
};
